import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { env } from "@/lib/env";

const FALLBACK_SUPABASE_URL = "https://azddwmbbocgccymtvkjk.supabase.co";
const FALLBACK_SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF6ZGR3bWJib2NnY2N5bXR2a2prIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzOTA5NjAsImV4cCI6MjA2Njk2Njk2MH0.CSH-wDqdDikpA0gy6sAxhpGyoW2QMpUYoNbqo3tThx8";

const supabaseUrl = env.VITE_SUPABASE_URL || FALLBACK_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY || FALLBACK_SUPABASE_ANON_KEY;

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
